import { Skeleton, Stack } from '@mui/material';

const NotificationFeedCellSkeleton = () => {
  return (
    <Stack
      direction="row"
      alignItems="start"
      gap={2}
      sx={{
        width: '100%',
        bgcolor: 'neutral00',
        py: 3,
        pr: 3,
        pl: 1.25,
      }}
      data-cy="notification-feed-skeleton"
    >
      <Stack direction="row" alignItems="center" gap={2}>
        {/* Read identifier */}
        <Skeleton variant="circular" width={8} height={8} />
        {/* Avatar */}
        <Skeleton variant="circular" width={36} height={36} />
      </Stack>

      <Stack
        gap={1}
        sx={{
          width: '100%',
          pt: 0.75,
        }}
      >
        {/* Texts */}
        <Skeleton variant="rounded" width="50%" height={12} />
        <Skeleton variant="rounded" width="100%" height={12} />
        <Skeleton variant="rounded" width="80%" height={12} />

        {/* Button */}
        <Skeleton variant="rounded" width="20%" height={30} />

        {/* Timestamp */}
        <Skeleton variant="rounded" width="30%" height={12} />
      </Stack>
    </Stack>
  );
};

export default NotificationFeedCellSkeleton;
